import { Alert } from "@mui/material";

// ----------------------------------------------------------------------

type Props = {
	errorMessage: string;
};

export const ErrorResult = ({ errorMessage }: Props) => {
	return (
		<Alert severity='error' sx={{ mb: 2, mt: 2, maxWidth: { xs: 250, sm: 330 } }}>
			{errorMessage}
		</Alert>
	);
};

export default ErrorResult;
